module.exports = __webpack_public_path__ + "img/icon-subscribe-2.5f2e7df5.svg";